// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* This file contains global variables based in the marketplace theme defined by
* 100 Ladrillos design system.
*/
/*
* ------------------------------------------------------------------------------
* Colors
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Typography
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Layout
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Icon sizes
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Shape
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Breakpoints
* ------------------------------------------------------------------------------
*/
/*
* NOTE: The width and style of the font has been set using font-face in the fonts.scss
* file. However, when the main font cannot be loaded those styles are not applied to
* the optional fonts, because they must be specified each time the font styles are
* assigned. To ensure the correct styles are applied, this mixin should be used.
*/
/*
* NOTE: The following mixin can be used to calculate the size of any css property
* in rem, however, the design system defines that only the font sizes would be
* calculated in REM to give the user the opportunity to change the size by
* configuring the browser.
*/
.src_js_components_Footer_footer-container {
  font-size: 0.875rem;
  width: 100%;
  background: #FFFFFF;
  position: relative;
}

.src_js_components_Footer_content {
  max-width: 1440px;
  height: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 110px;
  padding-top: 39px;
}

.src_js_components_Footer_content-marketplace {
  padding: 0 50px;
  padding-top: 39px;
}

.src_js_components_Footer_top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.src_js_components_Footer_about p {
  text-align: left;
}

.src_js_components_Footer_address p,
.src_js_components_Footer_address .src_js_components_Footer_link {
  text-align: left;
  margin: 0;
}

.src_js_components_Footer_bottom {
  margin-top: 30px;
  min-height: 45px;
  border-top: 1px solid #e1e1e1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 39px;
  padding-top: 8px;
}

.src_js_components_Footer_bottom p {
  color: #9c9c9c;
}

.src_js_components_Footer_marginB {
  margin-bottom: 12px;
}

.src_js_components_Footer_link {
  background: none;
  width: auto;
  height: auto;
  border: none;
  cursor: pointer;
  color: #5a9c8f;
  text-decoration: underline;
  font-size: 16px;
  margin: auto;
  padding: 0;
  color: #1C64EB;
  text-align: center;
  margin: 0;
  margin-left: 5px;
  font-size: 0.875rem;
}

.src_js_components_Footer_link:focus {
  outline: none;
}

.src_js_components_Footer_text {
  color: #3e3e3e;
  margin: 0;
  margin-bottom: 4px;
}

.src_js_components_Footer_text:not(:last-child) {
  margin-right: 5px;
}

.src_js_components_Footer_text:first-of-type {
  margin-left: 5px;
}

.src_js_components_Footer_brands {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.src_js_components_Footer_brand-logo {
  margin-right: 10px;
}

.src_js_components_Footer_tya-logo {
  width: 63.9px;
}

.src_js_components_Footer_grupo-guia-excelencia-inmobiliaria {
  width: 85.2px;
}

.src_js_components_Footer_grupo-4s-logo-360 {
  width: 105.5px;
}

.src_js_components_Footer_logo-kf-ventures-480 {
  width: 167.2px;
}

.src_js_components_Footer_investo-vc-logo-360 {
  width: 124.6px;
}

.src_js_components_Footer_group {
  width: 77.8px;
}

.src_js_components_Footer_about .src_js_components_Footer_contact-us {
  margin: 0 0 8px;
}

.src_js_components_Footer_promotions-info {
  width: 100%;
  display: flex;
  margin: 0;
}

.src_js_components_Footer_promotions-info .src_js_components_Footer_items-link {
  width: 100%;
}

.src_js_components_Footer_promotions-info .src_js_components_Footer_items-link li::marker {
  display: flex;
  color: #9c9c9c;
}

.src_js_components_Footer_promotions-info .src_js_components_Footer_items-link li {
  margin-bottom: 16px;
}

.src_js_components_Footer_disclaimer-info {
  flex-direction: column;
  text-align: left;
}

.src_js_components_Footer_fees-info {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.src_js_components_Footer_cnbv-logo .src_js_components_Footer_button-content {
  background: none;
  width: auto;
  height: auto;
  border: none;
  cursor: pointer;
  color: #5a9c8f;
  text-decoration: underline;
  font-size: 16px;
  margin: auto;
  padding: 0;
  margin-right: 32px;
  margin-top: 18px;
  margin-bottom: 32px;
  max-width: 140px;
}

.src_js_components_Footer_cnbv-logo .src_js_components_Footer_button-content:focus {
  outline: none;
}

.src_js_components_Footer_cnbv-logo .src_js_components_Footer_button-content img {
  max-width: 140px;
}

.src_js_components_Footer_resolution-link {
  display: flex;
}

.src_js_components_Footer_resolution-link p {
  margin-bottom: 16px;
  margin-top: 0;
}

.src_js_components_Footer_resolution-link p a {
  margin-top: 15px;
  margin-right: 5px;
}

.src_js_components_Footer_links-terms {
  display: flex;
  align-items: center;
}

@media (max-width: 1023px) {
  .src_js_components_Footer_brands-container {
    margin: 26px auto 0;
  }
  .src_js_components_Footer_brands-container .src_js_components_Footer_brands {
    margin: 26px auto 0;
    width: 100%;
    justify-content: flex-start;
  }
  .src_js_components_Footer_brands-container .src_js_components_Footer_brands > * {
    margin: 0 32px 16px 0;
  }
  .src_js_components_Footer_brands-container p {
    text-align: left;
  }
}

@media (max-width: 769px) {
  .src_js_components_Footer_content {
    padding: 39px 40px 0;
  }
  .src_js_components_Footer_top {
    width: 100%;
    margin: auto;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
  }
  .src_js_components_Footer_top > * {
    text-align: center;
  }
  .src_js_components_Footer_top > *:not(:last-child) {
    margin: 0 auto 16px;
  }
  .src_js_components_Footer_brands-container {
    margin: 26px auto 0;
  }
  .src_js_components_Footer_brands-container p {
    text-align: center;
  }
  .src_js_components_Footer_brands-container .src_js_components_Footer_brands {
    flex-direction: column;
    justify-content: center;
    margin: 0;
  }
  .src_js_components_Footer_brands-container .src_js_components_Footer_brands > * {
    margin: 16px 0;
  }
  .src_js_components_Footer_bottom {
    justify-content: center;
    margin: 0 16px;
  }
  .src_js_components_Footer_button-content {
    width: 100%;
    margin: 32px 0;
  }
  .src_js_components_Footer_address p,
  .src_js_components_Footer_address .src_js_components_Footer_link {
    text-align: center;
  }
  .src_js_components_Footer_cnbv-logo {
    display: flex;
    flex-direction: column;
  }
  .src_js_components_Footer_cnbv-logo .src_js_components_Footer_button-content {
    margin: 16px 0;
  }
  .src_js_components_Footer_promotions-info {
    padding: 0;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .src_js_components_Footer_promotions-info .src_js_components_Footer_items-link {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .src_js_components_Footer_promotions-info .src_js_components_Footer_items-link li {
    margin: 0;
    display: flex;
  }
  .src_js_components_Footer_resolution-link {
    text-align: center;
  }
  .src_js_components_Footer_resolution-link a {
    margin-top: 16px;
    margin-right: 5px;
  }
  .src_js_components_Footer_links-terms {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 16px 0;
  }
  .src_js_components_Footer_disclaimer-info {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .src_js_components_Footer_content {
    padding: 39px 0;
  }
  .src_js_components_Footer_top {
    flex-direction: column;
    align-items: center;
  }
  .src_js_components_Footer_top p {
    text-align: center;
  }
  .src_js_components_Footer_top a {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .src_js_components_Footer_top div:first-child p {
    margin-bottom: 20px;
  }
  .src_js_components_Footer_brands-container p {
    font-family: 'RobotoBold', arial, sans-serif;
    font-weight: 700;
    font-style: normal;
    margin-top: 0 !important;
    text-align: center;
  }
  .src_js_components_Footer_brand-logo {
    margin: 16px 0;
  }
  .src_js_components_Footer_bottom {
    justify-content: center;
  }
  .src_js_components_Footer_disclaimer {
    margin-top: 20px;
    text-align: center;
  }
  .src_js_components_Footer_fees-info {
    margin-top: 16px;
    padding-right: 16px;
    text-align: right;
  }
}
`, "",{"version":3,"sources":["webpack://./src/sass/theme-variables.scss","webpack://./src/js/components/Footer/style.scss","webpack://./src/sass/mixins.scss","webpack://./src/sass/variables.scss"],"names":[],"mappings":"AAAA;;;CCGC;ADED;;;;CCGC;AD0BD;;;;CCrBC;ADyFD;;;;CCpFC;ADkGD;;;;CC7FC;ADuGD;;;;CClGC;ADyGD;;;;CCpGC;ACaD;;;;;CDPC;AC2ED;;;;;CDrEC;AA5CD;ECwHE,mBAAoC;EDtHpC,WAAW;EACX,mBDYa;ECXb,kBAAkB;AA8CpB;;AA3CA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AA8CnB;;AA3CA;EACE,eAAe;EACf,iBAAiB;AA8CnB;;AA3CA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AA8CjB;;AA3CA;EACE,gBAAgB;AA8ClB;;AA3CA;;EAGI,gBAAgB;EAChB,SAAS;AA6Cb;;AAzCA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BE3BoB;EF4BpB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AA4ClB;;AApDA;EAWI,cEXmB;AFwDvB;;AAzCA;EACE,mBAAmB;AA4CrB;;AAzCA;EC/BE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cCJkB;EDKlB,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,UAAU;EDwBV,cEnCkB;EFoClB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;ECuDhB,mBAAoC;ADDtC;;AA3DA;ECnBI,aAAa;ADkFjB;;AAtDA;EACE,cEzBqB;EF0BrB,SAAS;EACT,kBAAkB;AAyDpB;;AA5DA;EAMI,iBAAiB;AA0DrB;;AAhEA;EAUI,gBAAgB;AA0DpB;;AAtDA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AAyDrB;;AAtDA;EACE,kBAAkB;AAyDpB;;AAtDA;EACE,aAAa;AAyDf;;AAtDA;EACE,aAAa;AAyDf;;AAtDA;EACE,cAAc;AAyDhB;;AAtDA;EACE,cAAc;AAyDhB;;AAtDA;EACE,cAAc;AAyDhB;;AAtDA;EACE,aAAa;AAyDf;;AAtDA;EACE,eAAe;AAyDjB;;AAtDA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AAyDX;;AA5DA;EAMI,WAAW;AA0Df;;AAhEA;EASM,aAAa;EACb,cE1FiB;AFqJvB;;AArEA;EAcM,mBAAmB;AA2DzB;;AAtDA;EACE,sBAAsB;EACtB,gBAAgB;AAyDlB;;AAtDA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAyD3B;;AAtDA;EC1HE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cCJkB;EDKlB,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,UAAU;EDoHR,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAiEpB;;AAvEA;EC9GI,aAAa;ADyLjB;;AA3EA;EASM,gBAAgB;AAsEtB;;AAjEA;EACE,aAAa;AAoEf;;AArEA;EAII,mBAAmB;EACnB,aAAa;AAqEjB;;AA1EA;EAQM,gBAAgB;EAChB,iBAAiB;AAsEvB;;AAjEA;EACE,aAAa;EACb,mBAAmB;AAoErB;;AAjEA;EACE;IACE,mBAAmB;EAoErB;EArEA;IAII,mBAAmB;IACnB,WAAW;IACX,2BAA2B;EAoE/B;EA1EA;IASM,qBAAqB;EAoE3B;EA7EA;IAcI,gBAAgB;EAkEpB;AACF;;AA9DA;EACE;IACE,oBAAoB;EAiEtB;EA9DA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EAgEnB;EAtEA;IASI,kBAAkB;EAgEtB;EAzEA;IAYM,mBAAmB;EAgEzB;EA3DA;IACE,mBAAmB;EA6DrB;EA9DA;IAII,kBAAkB;EA6DtB;EAjEA;IAQI,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EA4Db;EAtEA;IAaM,cAAc;EA4DpB;EAvDA;IACE,uBAAuB;IACvB,cAAc;EAyDhB;EAtDA;IACE,WAAW;IACX,cAAc;EAwDhB;EArDA;;IAGI,kBAAkB;EAsDtB;EAlDA;IACE,aAAa;IACb,sBAAsB;EAoDxB;EAtDA;IAKI,cAAc;EAoDlB;EAhDA;IACE,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EAkDpB;EAtDA;IAOI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EAkDvB;EA3DA;IAYM,SAAS;IACT,aAAa;EAkDnB;EA7CA;IACE,kBAAkB;EA+CpB;EAhDA;IAII,gBAAgB;IAChB,iBAAiB;EA+CrB;EA3CA;IACE,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EA6ChB;EA1CA;IACE,kBAAkB;EA4CpB;AACF;;AAzCA;EACE;IACE,eAAe;EA4CjB;EAzCA;IACE,sBAAsB;IACtB,mBAAmB;EA2CrB;EA7CA;IAKI,kBAAkB;EA2CtB;EAhDA;IASI,WAAW;IACX,aAAa;IACb,uBAAuB;EA0C3B;EArDA;IAgBM,mBAAmB;EAwCzB;EAnCA;IClQE,4CAA4C;IAC5C,gBAAgB;IAChB,kBAAkB;IDoQhB,wBAAwB;IACxB,kBAAkB;EAqCtB;EAjCA;IACE,cAAc;EAmChB;EAhCA;IACE,uBAAuB;EAkCzB;EA/BA;IACE,gBAAgB;IAChB,kBAAkB;EAiCpB;EA9BA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EAgCnB;AACF","sourcesContent":["/*\n* This file contains global variables based in the marketplace theme defined by\n* 100 Ladrillos design system.\n*/\n\n/*\n* ------------------------------------------------------------------------------\n* Colors\n* ------------------------------------------------------------------------------\n*/\n$grayC: #EAEAEA;\n$grayE: #BDBCBC;\n$grayG: #8C8C8C;\n$grayH: #7E7C7C;\n$grayI: #3E3E3E;\n$grayJ: #4A4A4A;\n$white: #FFFFFF;\n$green1: #47CBC3;\n$pink-dark: #F69699;\n$green: #65b212;\n$coral-pink: #FF5A60;\n$alternative-2-dark: #e59206;\n\n$alternative3: $blue;\n$alternative3-light: $blueLight;\n$alternative1-main: $green1;\n$disabled-main: $grayC;\n$disabled-contrast: $grayG;\n$hbBackgroundA: $white;\n$shape: $grayC;\n$secondary-dark: $pink-dark;\n$alternative4: $green;\n$primary-main: $coral-pink;\n$info-main: $blue;\n/*\n* ------------------------------------------------------------------------------\n* Typography\n* ------------------------------------------------------------------------------\n*/\n$typography-h1: (\n  'font-size': 22,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayI,\n  'letter-spacing': 0.4,\n  'font-style': 'normal',\n);\n\n$typography-h2: (\n  'font-size': 20,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayI,\n  'letter-spacing': 0,\n  'font-style': 'normal',\n);\n\n$typography-h3: (\n  'font-size': 18,\n  'font-family': 'RobotoMedium',\n  'font-weigth': 500,\n  'color': $grayI,\n  'letter-spacing': 0,\n  'font-style': 'normal',\n);\n\n$typography-subtitle: (\n  'font-size': 14,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayH,\n  'letter-spacing': 0.4,\n  'font-style': 'normal',\n);\n\n$typography-body1: (\n  'font-size': 14,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayI,\n  'letter-spacing': 0,\n  'font-style': 'normal',\n);\n\n$typography-body2: (\n  'font-size': 14,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayI,\n  'letter-spacing': 0.4,\n  'font-style': 'normal',\n);\n\n$typography-body3: (\n  'font-size': 14,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayH,\n  'letter-spacing': 0.4,\n  'font-style': 'normal',\n);\n\n/*\n* ------------------------------------------------------------------------------\n* Layout\n* ------------------------------------------------------------------------------\n*/\n$layout-unit: 8;\n$layout-unit-small: 4;\n$layout-padding-extra-small: 8;\n$layout-padding-small: 16;\n$layout-padding-regular: 24;\n$layout-padding-large: 32;\n$layout-margin-small: 16;\n$layout-margin-regular: 32;\n\n/*\n* ------------------------------------------------------------------------------\n* Icon sizes\n* ------------------------------------------------------------------------------\n*/\n$icon-extra-small: 8;\n$icon-extra-small: 16;\n$icon-extra-medium: 24;\n$icon-extra-large: 40;\n\n/*\n* ------------------------------------------------------------------------------\n* Shape\n* ------------------------------------------------------------------------------\n*/\n$border-radius-extra-small: 4;\n\n/*\n* ------------------------------------------------------------------------------\n* Breakpoints\n* ------------------------------------------------------------------------------\n*/\n$breakpoint-small: 480;\n$breakpoint-medium: 769;\n$breakpoint-large: 1023;\n$breakpoint-extra-large: 1440;\n","@import \"variables\";@import \"mixins\";\n.footer-container {\n  @include toRem('font-size', 14);\n  width: 100%;\n  background: $white;\n  position: relative;\n}\n\n.content {\n  max-width: 1440px;\n  height: 100%;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 110px;\n  padding-top: 39px;\n}\n\n.content-marketplace {\n  padding: 0 50px;\n  padding-top: 39px;\n}\n\n.top {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.about p {\n  text-align: left;\n}\n\n.address {\n  p,\n  .link {\n    text-align: left;\n    margin: 0;\n  }\n}\n\n.bottom {\n  margin-top: 30px;\n  min-height: 45px;\n  border-top: 1px solid $border-color;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  padding-bottom: 39px;\n  padding-top: 8px;\n\n  p {\n    color: $warm-grey-two;\n  }\n}\n\n.marginB {\n  margin-bottom: 12px;\n}\n\n.link {\n  @include linkButton;\n  color: $blue-link2;\n  text-align: center;\n  margin: 0;\n  margin-left: 5px;\n  @include toRem('font-size', 14);\n}\n\n.text {\n  color: $greyish-brown;\n  margin: 0;\n  margin-bottom: 4px;\n\n  &:not(:last-child) {\n    margin-right: 5px;\n  }\n\n  &:first-of-type {\n    margin-left: 5px;\n  }\n}\n\n.brands {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.brand-logo {\n  margin-right: 10px;\n}\n\n.tya-logo {\n  width: 63.9px;\n}\n\n.grupo-guia-excelencia-inmobiliaria {\n  width: 85.2px;\n}\n\n.grupo-4s-logo-360 {\n  width: 105.5px;\n}\n\n.logo-kf-ventures-480 {\n  width: 167.2px;\n}\n\n.investo-vc-logo-360 {\n  width: 124.6px;\n}\n\n.group {\n  width: 77.8px;\n}\n\n.about .contact-us {\n  margin: 0 0 8px;\n}\n\n.promotions-info {\n  width: 100%;\n  display: flex;\n  margin: 0;\n\n  .items-link {\n    width: 100%;\n\n    li::marker {\n      display: flex;\n      color: $warm-grey-two;\n    }\n\n    li {\n      margin-bottom: 16px;\n    }\n  }\n}\n\n.disclaimer-info {\n  flex-direction: column;\n  text-align: left;\n}\n\n.fees-info {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.cnbv-logo {\n  .button-content {\n    @include linkButton;\n    margin-right: 32px;\n    margin-top: 18px;\n    margin-bottom: 32px;\n    max-width: 140px;\n\n    img {\n      max-width: 140px;\n    }\n  }\n}\n\n.resolution-link {\n  display: flex;\n\n  p {\n    margin-bottom: 16px;\n    margin-top: 0;\n\n    a {\n      margin-top: 15px;\n      margin-right: 5px;\n    }\n  }\n}\n\n.links-terms {\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: $horizontal-tablet) {\n  .brands-container {\n    margin: 26px auto 0;\n\n    .brands {\n      margin: 26px auto 0;\n      width: 100%;\n      justify-content: flex-start;\n\n      & > * {\n        margin: 0 32px 16px 0;\n      }\n    }\n\n    p {\n      text-align: left;\n    }\n  }\n}\n\n@media (max-width: $vertical-tablet) {\n  .content {\n    padding: 39px 40px 0;\n  }\n\n  .top {\n    width: 100%;\n    margin: auto;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: nowrap;\n\n    & > * {\n      text-align: center;\n\n      &:not(:last-child) {\n        margin: 0 auto 16px;\n      }\n    }\n  }\n\n  .brands-container {\n    margin: 26px auto 0;\n\n    p {\n      text-align: center;\n    }\n\n    .brands {\n      flex-direction: column;\n      justify-content: center;\n      margin: 0;\n\n      & > * {\n        margin: 16px 0;\n      }\n    }\n  }\n\n  .bottom {\n    justify-content: center;\n    margin: 0 16px;\n  }\n\n  .button-content {\n    width: 100%;\n    margin: 32px 0;\n  }\n\n  .address {\n    p,\n    .link {\n      text-align: center;\n    }\n  }\n\n  .cnbv-logo {\n    display: flex;\n    flex-direction: column;\n\n    .button-content {\n      margin: 16px 0;\n    }\n  }\n\n  .promotions-info {\n    padding: 0;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n\n    .items-link {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      li {\n        margin: 0;\n        display: flex;\n      }\n    }\n  }\n\n  .resolution-link {\n    text-align: center;\n\n    a {\n      margin-top: 16px;\n      margin-right: 5px;\n    }\n  }\n\n  .links-terms {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    margin: 16px 0;\n  }\n\n  .disclaimer-info {\n    text-align: center;\n  }\n}\n\n@media (max-width: $mobile) {\n  .content {\n    padding: 39px 0;\n  }\n\n  .top {\n    flex-direction: column;\n    align-items: center;\n\n    p {\n      text-align: center;\n    }\n\n    a {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n    }\n\n    div:first-child {\n      p {\n        margin-bottom: 20px;\n      }\n    }\n  }\n\n  .brands-container {\n    p {\n      @include fontFamily('RobotoBold');\n\n      margin-top: 0 !important;\n      text-align: center;\n    }\n  }\n\n  .brand-logo {\n    margin: 16px 0;\n  }\n\n  .bottom {\n    justify-content: center;\n  }\n\n  .disclaimer {\n    margin-top: 20px;\n    text-align: center;\n  }\n\n  .fees-info {\n    margin-top: 16px;\n    padding-right: 16px;\n    text-align: right;\n  }\n}\n","$prefixes: \"webkit\", \"moz\", \"ms\", \"o\", \"none\";\n\n@mixin object-fit($object-fit) {\n  -o-object-fit: $object-fit;\n  object-fit: $object-fit;\n}\n\n@mixin transform($property) {\n  -webkit-transform: $property;\n  -ms-transform: $property;\n  transform: $property;\n}\n\n@mixin appearance($appaerence) {\n  -webkit-appearance: $appaerence;\n  -moz-appearance: $appaerence;\n  appearance: $appaerence;\n}\n\n@mixin prefix($property, $arguments) {\n  @each $prefix in $prefixes {\n    @if $prefix == \"none\" {\n      #{$property}: $arguments;\n    } @else {\n      -#{$prefix}-#{$property}: $arguments;\n    }\n  }\n}\n\n@mixin linkButton() {\n  background: none;\n  width: auto;\n  height: auto;\n  border: none;\n  cursor: pointer;\n  color: $green-link;\n  text-decoration: underline;\n  font-size: 16px;\n  margin: auto;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n/*\n* NOTE: The width and style of the font has been set using font-face in the fonts.scss\n* file. However, when the main font cannot be loaded those styles are not applied to\n* the optional fonts, because they must be specified each time the font styles are\n* assigned. To ensure the correct styles are applied, this mixin should be used.\n*/\n@mixin fontFamily($fontFamily) {\n  @if $fontFamily == 'Roboto' {\n    font-family: 'Roboto', arial, sans-serif;\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoItalic' {\n    font-family: 'RobotoItalic', arial, sans-serif;\n    font-weight: 400;\n    font-style: italic;\n  }\n\n  @if $fontFamily == 'RobotoMedium' {\n    font-family: 'RobotoMedium', arial, sans-serif;\n    font-weight: 500;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoMediumItalic' {\n    font-family: 'RobotoMediumItalic', arial, sans-serif;\n    font-weight: 500;\n    font-style: italic;\n  }\n\n  @if $fontFamily == 'RobotoBold' {\n    font-family: 'RobotoBold', arial, sans-serif;\n    font-weight: 700;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoBoldItalic' {\n    font-family: 'RobotoBoldItalic', arial, sans-serif;\n    font-weight: 700;\n    font-style: italic;\n  }\n\n  @if $fontFamily == 'RobotoCondensed' {\n    font-family: 'RobotoCondensed', arial, sans-serif;\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoCondensedItalic' {\n    font-family: 'RobotoCondensedItalic', arial, sans-serif;\n    font-weight: 400;\n    font-style: italic;\n  }\n\n  @if $fontFamily == 'RobotoCondensedBold' {\n    font-family: 'RobotoCondensedBold', arial, sans-serif;\n    font-weight: 700;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoCondensedBoldItalic' {\n    font-family: 'RobotoCondensedBoldItalic', arial, sans-serif;\n    font-weight: 700;\n    font-style: italic;\n  }\n}\n\n/*\n* NOTE: The following mixin can be used to calculate the size of any css property\n* in rem, however, the design system defines that only the font sizes would be\n* calculated in REM to give the user the opportunity to change the size by\n* configuring the browser.\n*/\n@mixin toRem($property, $value, $unit: $sizing-unit-base) {\n  #{$property}: ($value / $unit) + rem;\n}\n","$sizing-unit-base: 16;\n\n// Screen sizes\n$large-screen: 1440px;\n$regular-screen: 1280px;\n$small-screen: 1023px;\n$horizontal-tablet: $small-screen;\n$vertical-tablet: 769px;\n$big-mobile: 576px;\n$mobile: 480px;\n$medium-mobile: 375px;\n$small-mobile: 320px;\n\n// Product colors\n$primary-color: #ff5a60;\n$secondary-color: #0477c0;\n$error-color: #ae3c40;\n$success-color: #3ab398;\n$border-color: #e1e1e1;\n$app-bg-color: #f8f8f8;\n\n// Screen Loaders\n$grey-placeholder: #e7e8e9;\n\n// Colors\n$green: #48b83b;\n$cerulean: #0477c0;\n$blue-link: #4087e8;\n$blue-link2: #1C64EB;\n$blue-ocean: #298de1;\n$greeny-blue: rgb(58, 179, 152);\n$green-link: #5a9c8f;\n$white: #ffffff;\n$white-one: #fefefe;\n$white-two: #d8d8d8;\n$white-eleven: $app-bg-color;\n$white-twelve: #f4f4f4;\n$white-alt: #fbfbfb;\n$gray: #f8f8f8;\n$border-grey: #cbcbcb;\n$weak-grey: #7e7c7c;\n$warm-grey: #9b9b9b;\n$warm-grey-two: #9c9c9c;\n$warm-grey-three: #898989;\n$strong-grey: #757171;\n$disabled-grey: #edebeb;\n$greyish-brown: #3e3e3e;\n$greyish-light: #5f5f5f;\n$light-grey: #a6a6a6;\n$soft-pink: #feabae;\n$light-pink: #ffeaea;\n$very-light-pink: #fff4f4;\n$orange: #edab41;\n$rust-orange: #c17f15;\n$red-error: #a1062c;\n$red-error-main: #D40707;\n$red-error-light: #FBDCDC;\n$white-seven: #f9f9f9;\n$white-eight: #dedede;\n$dark-sky-blue: #4a90e2;\n$coral: #f05754;\n$very-light-blue: #f3faf9;\n$tomato: #f53923;\n$dark-background-with-transparency: rgba(0, 0, 0, 0.6);\n$blueDarker: #034D8C;\n$blueDark: #0267BD;\n$blue: #0178DD;\n$blueLight: #3CA4FC;\n$blueLighter: #5DAFF5;\n$backgroundColor1: #E7F4FF;\n\n\n// toast colors\n$primary: #ff5a60;\n$warning: #f5a623;\n$sucess: #7ed321;\n$danger: #a1062c;\n$info: #0178dd;\n$primary-dark: #CE2E33;\n\n// simulator\n$investment-blue: #2dc1d4;\n\n// Button\n$button-border-radius: 24px;\n$button-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);\n\n// Card\n$card-border-radius: 5px;\n$card-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.12),\n  0 0 2px 0 rgba(0, 0, 0, 0.14);\n$card-background-color: $white;\n\n// Table\n$alternate-row: #f1f1f1;\n$header-background: $warm-grey-two;\n\n// Panel\n$panel-border: 1px solid #e3e3e3;\n\n// Modal\n$modal-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.12),\n  0 0 2px 0 rgba(0, 0, 0, 0.14);\n\n// Application\n$main-container-padding: 0 15px;\n\n// Application / Header\n$header-height: 75px;\n$header-bg-color: #fafafa;\n\n// Application / Sidenav\n$sidenav-width: 150px;\n$sidenav-bg-color: $white;\n$sidenav-item-height: 63px;\n\n// Application / Tabs\n$tab-border-radius: 3px;\n$active-tab-bg-color: $primary-color;\n$inactive-tab-bg-color: $border-grey;\n\n// Application / Mobile menu\n$header-height: 72px;\n$acount-info-height: 63px * 2;\n$nav-top: $header-height + $acount-info-height;\n\n// Enrollment / Sidenav\n$enrollment-sidenav-width: 296px;\n\n@import './theme-variables.scss';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer-container": `src_js_components_Footer_footer-container`,
	"content": `src_js_components_Footer_content`,
	"content-marketplace": `src_js_components_Footer_content-marketplace`,
	"top": `src_js_components_Footer_top`,
	"about": `src_js_components_Footer_about`,
	"address": `src_js_components_Footer_address`,
	"link": `src_js_components_Footer_link`,
	"bottom": `src_js_components_Footer_bottom`,
	"marginB": `src_js_components_Footer_marginB`,
	"text": `src_js_components_Footer_text`,
	"brands": `src_js_components_Footer_brands`,
	"brand-logo": `src_js_components_Footer_brand-logo`,
	"tya-logo": `src_js_components_Footer_tya-logo`,
	"grupo-guia-excelencia-inmobiliaria": `src_js_components_Footer_grupo-guia-excelencia-inmobiliaria`,
	"grupo-4s-logo-360": `src_js_components_Footer_grupo-4s-logo-360`,
	"logo-kf-ventures-480": `src_js_components_Footer_logo-kf-ventures-480`,
	"investo-vc-logo-360": `src_js_components_Footer_investo-vc-logo-360`,
	"group": `src_js_components_Footer_group`,
	"contact-us": `src_js_components_Footer_contact-us`,
	"promotions-info": `src_js_components_Footer_promotions-info`,
	"items-link": `src_js_components_Footer_items-link`,
	"disclaimer-info": `src_js_components_Footer_disclaimer-info`,
	"fees-info": `src_js_components_Footer_fees-info`,
	"cnbv-logo": `src_js_components_Footer_cnbv-logo`,
	"button-content": `src_js_components_Footer_button-content`,
	"resolution-link": `src_js_components_Footer_resolution-link`,
	"links-terms": `src_js_components_Footer_links-terms`,
	"brands-container": `src_js_components_Footer_brands-container`,
	"disclaimer": `src_js_components_Footer_disclaimer`
};
export default ___CSS_LOADER_EXPORT___;
